import { baseServiceRequest } from "../baseServiceRequest"
import type { ISendCorrespondence } from "./types"

export const sendMailCorrespondence = async (
  data: ISendCorrespondence,
): Promise<ISendCorrespondence> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: "/correspondence/mail",
    data: data,
  })
  return response.data
}

export const sendEmailCorrespondence = async (
  data: ISendCorrespondence,
): Promise<ISendCorrespondence> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: "/correspondence/email",
    data: data,
  })
  return response.data
}
